import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router } from '@angular/router';

import { ModeOfPaymentProperties } from '../models/ModeOfPaymentProperties';

import { ModeOfPaymentService } from '../Services/mode-of-payment.service';
import { NgForm } from '@angular/forms';
import { Component } from '@angular/core';
declare var $;

@Component({
    selector: 'app-mode-of-payment',
    templateUrl: './mode-of-payment.component.html',
    styleUrls: ['./mode-of-payment.component.css']
})
/** ModeOfPayment component*/
export class ModeOfPaymentComponent {
    /** ModeOfPayment ctor */
  all$: ModeOfPaymentProperties[];
  obj = new ModeOfPaymentProperties();
  constructor(private service: ModeOfPaymentService, private router: Router) {
    this.onClickEdit = this.onClickEdit.bind(this);
    // this.onClickEditSupplierAir = this.onClickEditSupplierAir.bind(this);
    //this.onClickEditSupplierVisa = this.onClickEditSupplierVisa.bind(this);
  }


  ngOnInit() {

    try {
      this.loadAllModeOfPayment();

    } catch (ex) {  }
  }
  loadAllModeOfPayment() {
    this.service.getAllModeOfPayment().subscribe((data) => {
      this.all$ = (data);
      //console.log(this.all$);


    })
  }
  onClickEdit(e) {
    //  //console.log(e);
    //console.log(e.row.data.modeOfPaymentId);
    this.service.getDepositTypeById(e.row.data.modeOfPaymentId).subscribe((data) => {
      this.obj = data;
    })

  }
  Save() {
    // this.obj.creationUser = 1;
    if (this.obj.creationUser == 0 || this.obj.creationUser == null) {
      this.obj.creationUser = Number(localStorage.getItem("UserId"));
      this.service.create(this.obj).subscribe((data) => {
        if (data == true) {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Saved..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllModeOfPayment();
        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllModeOfPayment();
        }

      })
    }
    else {
      this.obj.modifyUser = Number(localStorage.getItem("UserId"));
      this.service.update(this.obj).subscribe((data) => {
        if (data == true) {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Saved..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllModeOfPayment();
        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllModeOfPayment();
        }
      })
    }
  }
  Cancel() {
    this.obj = new ModeOfPaymentProperties();
  }
}
